import React, { Component } from 'react';

import Row from './row';
import ExpandedRow from './expander-row';
import Pagination from '../../../shared/pagination';

import './main.less';

const Table = props => {

	const { table, intl, pagination, gotoPage }  = props;

	return (
		<div
			className="table-container top-affiliates-table"
		>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr className="top-affiliates-table-top-row">
						{
							table.headers
								.map((header, i) =>
									<th key={i} className={header.className || ''}>{intl(header.title)}</th>
								)
						}
						{table.intervals.map((header, i) =>
							<th key={i} className='text-center'>{intl(header)}</th>
						)}
						<th className='text-center'>Total</th>
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) =>
						row.offer_geo ?
							<ExpandedRow
								{...props} key={i} row={row} intervals={table.intervals} row_num={i}
							/> :
							<Row
								key={i} {...props} row={row} intervals={table.intervals} row_num={i}
							/>
					)}
				</tbody>
			</table>
			<p className="flex-center pagination-container">
				<Pagination pagination={pagination} gotoPage={gotoPage} />
			</p>
		</div>
	);
};

class TableContainer extends Component {
	constructor(props) {
		super(props);
	}
	componentWillUnmount() {
		document.removeEventListener('copy', handleCopy);
		if (this.props.can('canCopyTotalRow')) {
			document.querySelectorAll('.top-affiliate-total-row').forEach(el => {
				el.removeEventListener('copy', handleCopyFromTotalRow);
			});
		}
	}
	componentDidMount() {
		document.removeEventListener('copy', handleCopy);
		document.addEventListener('copy', handleCopy);
		if (this.props.can('canCopyTotalRow')) {
			document.querySelectorAll('.top-affiliate-total-row').forEach(el => {
				el.removeEventListener('copy', handleCopyFromTotalRow);
				el.addEventListener('copy', handleCopyFromTotalRow);
			});
		}
	}

	render() {
		window.allowedToCopyWords = this.props.allowedToCopyWords;
		const { table } = this.props;

		return <div>
			<div className="top-affiliates-table-additional-scroll">
				<table>
					<thead>
						<tr className="top-affiliates-table-top-row">
							{
								table.headers
									.map((header, i) =>
										<th key={i} className={header.className || ''}/>
									)
							}
							{table.intervals.map((header, i) =>
								<th key={i}/>
							)}
							<th/>
						</tr>
					</thead>
				</table>
			</div>
			<Table {...this.props} />
		</div>;
	}
}

function handleCopy(e) {
	const allowedToCopyWords = window.allowedToCopyWords || [];

	const text = window
		.getSelection()
		.toString()
		.split('š')
		.filter(Boolean)
		.map(row => row.replace(/[\n\r]+/g, '\t')
			.split('\t')
			.filter(item => allowedToCopyWords.some(aw => item.includes(aw)))
			.join('\t')
		)
		.join('\n');

	e.clipboardData.setData('text/plain', text);
	e.preventDefault();
}

function handleCopyFromTotalRow(e) {
	e.stopPropagation();
}

export default TableContainer;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-affiliates/components/table/main.js